module.exports = __webpack_public_path__ + "img/border-inner.e57f2f81.svg";